import { Button, Grid, Link, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "48px",
  background: "#FFF",

  [props.theme.breakpoints.down("lg")]: {
    padding: "56px 32px",
    gap: "40px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 24px",
    gap: "48px",
    alignItems: "flex-start",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "auto",
  flexDirection: "column",
  alignItems: "center",

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    gap: "16px",
    alignItems: "center",
  },
}));

export const TaglineContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  alignSelf: "stretch",
  justifyContent: "center",
  width: "100%",
  textAlign: "left",
  maxWidth: "1200px",
  margin: "auto",

  [props.theme.breakpoints.down("lg")]: {
    // maxWidth: "392px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "none",
    alignItems: "flex-start",
    width: "100%",
    textAlign: "left",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  fontStyle: "normal",
  lineHeight: "48px",
  fontFamily: "Georgia",
  letterSpacing: "0.06px",
  textAlign: "left",

  i: {
    fontStyle: "italic",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "36px",
    lineHeight: "43.2px",
    letterSpacing: "0.36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
  },
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: "Inter",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "30px",
  letterSpacing: "0.03px",
  alignSelf: "stretch",
  maxWidth: "1200px",
  margin: "0 auto",
  textAlign: "left",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22.4px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  maxWidth: "1200px",
  width: "100%",
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "space-between",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    gap: "24px",
    flexDirection: "column",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "280px",
  width: "280px",
  borderRadius: "50%",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "180px",
    maxWidth: "180px",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: "8px",
  minWidth: "280px",
  textAlign: "center",

  [props.theme.breakpoints.down("lg")]: {
    alignItems: "center",
    textAlign: "center",
    minWidth: "180px",
    gap: "4px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "4px",
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: props.type == "desc" ? "rgba(0, 0, 0, 0.60)" : "rgba(0, 0, 0, 0.87)",
  fontFamily: props.type == "desc" ? "Inter" : "Inter",
  fontSize: props.type == "desc" ? "20px" : "24px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 400 : 600,
  lineHeight: props.type == "desc" ? "30px" : "36px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.03px" : "unset",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: props.type == "desc" ? "14px" : "16px",
    lineHeight: props.type == "desc" ? "21px" : "24px",
    letterSpacing: props.type == "desc" ? "0.15px" : "0.15px",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
    fontWeight: 700,
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "220px",
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const LinkStyled = styling(Link)((props) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "row",
  gap: "5px",
  color: "#512ACC",
  fontSize: "16px",
  fontWeight: "700",
  textDecoration: "none",
  lineHeight: "24px",
  letterSpacing: "0.15px",
  alignItems: "center",

  "&:hover": {
    color: "#40249B",
  },
}));

export const LineBreak = styling("div")((props) => ({
  height: 0,
  width: "100px",
  borderTop: "4px dashed #261754",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    width: 0,
    height: "60px",
    borderTop: "none",
    borderLeft: "2px dotted #261754",
  },
}));
